module.exports = __webpack_public_path__ + "img/screen-1.687ee25e.png";